import { render } from "./Homepage.vue?vue&type=template&id=0b277d48&scoped=true&ts=true"
import script from "./Homepage.vue?vue&type=script&lang=ts"
export * from "./Homepage.vue?vue&type=script&lang=ts"

import "./Homepage.vue?vue&type=style&index=0&id=0b277d48&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/medix_envato_v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b277d48"]])

export default __exports__